<script>
	export let data;
	import { slide, fade } from "svelte/transition";
	import { request } from "../../../../scripts/request";
	import { isMobile } from "../../../../stores/variables";

	let form;
	let currentTheme;
	let showDelete = false;
	let INDEX = -1;
	let DATA = data;
	let isDeletePressed = false;
	let themes = [
		{
			name: "компактная",
			cls: "comp",
		},
		{
			name: "информативная",
			cls: "inf",
		},
	];

	if (localStorage.getItem("theme")) {
		currentTheme = localStorage.getItem("theme");
		themes.forEach((t) => {
			if (t.cls == currentTheme) {
				t.active = true;
			}
		});
	}
	if (!currentTheme) {
		currentTheme = themes[0].cls;
		themes[0].active = true;
	}

	function handleTheme(cls) {
		currentTheme = cls;
		localStorage.setItem("theme", cls);
	}
	function handleResult(i, result) {
		DATA.newData[DATA.field_name][i].active = false;
		DATA.newData[DATA.field_name][i].buttonHandler = 0;
		DATA.newData[DATA.field_name][i].requestHandler = 1;
	}
	function handleSave(ID, i) {
		DATA.newData[DATA.field_name][i].buttonHandler = "save";
		let data = {
			id: +ID,
			action: "save",
		};
		let d = request.fetchData(
			"moderationrequest",
			"save_request",
			data,
			{},
			form
		);
		d.then((result) => {
			handleResult(i, result);
		});
	}
	function handleCancel(ID, ChangeStatusReason = "", i) {
		DATA.newData[DATA.field_name][i].buttonHandler = "cancel";
		let data = {
			id: +ID,
			action: "reject",
			reason: ChangeStatusReason,
		};

		showDelete = true;
		INDEX = i;

		let d = request.fetchData(
			"moderationrequest",
			"reject_request",
			data,
			{},
			form
		);
		d.then((result) => {
			handleResult(i, result);
		});
	}
	async function handeDelete(clinicID) {
		let data = {
			id: +clinicID,
		};
		let url = "clinic";
		let response = await request.fetchData(url, "deleteClinic", data, {
			method: "DELETE",
		});
		if (response) {
			isDeletePressed = true;
			setTimeout(() => {
				isDeletePressed = false;
				location.reload();
			}, 1500);
		}
	}

	if (data) {
		if (!data.newData) data.newData = [];
		if (!data.requests) data.requests = [];
		if (data.newData[data.field_name]) {
			data.requests = data.newData[data.field_name];
		}
	}
</script>

<form bind:this={form} style="display:none" />
{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if isDeletePressed}
	<div class="popup" class:active={isDeletePressed} transition:fade>
		<div
			class="popup__bg"
			on:click={() => {
				isDeletePressed = "";
				location.reload();
			}}
		/>
		<div class="popup__body">
			<i
				class="fas fa-times popup__cross"
				on:click={() => {
					isDeletePressed = "";
					location.reload();
				}}
			/>
			<b>Клиника успешно удалена!</b>
		</div>
	</div>
{/if}

<div class="themes">
	<span class="themes__title">Режим отображения</span>
	<div class="themes__options">
		{#each themes as { name, cls, active }, i}
			<span
				on:click={() => {
					handleTheme(cls);
					themes.forEach((t) => {
						t.active = false;
					});
					active = !active;
				}}
				class="themes__option {active ? 'active' : ''}">{name}</span
			>
		{/each}
	</div>
</div>

{#if data.requests}
	<div class="mod {currentTheme}">
		<ul class="mod__list">
			{#each data.requests as _request, i}
				<li class="mod__item">
					{#if DATA.newData[DATA.field_name][i].requestHandler}
						<div class="mod__item-handled">
							<span>Заявка рассмотрена</span>

							{#if _request.Resource == "iMedClinic" && _request.Action == "add" && _request.Clinic.ID && showDelete && INDEX == i}
								<span
									style={"cursor: pointer;"}
									on:click={() =>
										handeDelete(_request.Clinic.ID)}
								>
									Удалить клинику</span
								>
							{/if}
						</div>
					{/if}
					<div
						class="mod__item-clickable"
						on:click={() => {
							DATA.newData[DATA.field_name][i].active = true;
						}}
					/>
					<div class="mod__item-header">
						{#if _request.Doctor}
							<div class="mod__clinic">
								<span>
									Специалист:
									{#if _request.Doctor.url}
										<a
											href={_request.Doctor.url}
											target="_blank"
										>
											{#if _request.Doctor.Name}
												{_request.Doctor.Name}
											{:else}
												{"Без имени"}
											{/if}
										</a>
									{:else}
										<span>
											{#if _request.Doctor.Name}
												{_request.Doctor.Name}
											{:else}
												{"Без имени"}
											{/if}
										</span>
									{/if}
								</span>
							</div>
						{/if}
						{#if _request.Clinic}
							{#if _request.Clinic.Image}
								<div
									class="mod__image"
									style="margin-right: auto;"
								>
									<img src={_request.Clinic.Image} alt="" />
								</div>
							{:else}
								<div class="mod__image blank">
									<img src="/img/questionmark.svg" alt="" />
								</div>
							{/if}
							<div class="mod__title">
								<span>
									Клиника:
									{#if _request.Clinic.url}
										<a
											href={_request.Clinic.url}
											target="_blank"
										>
											{#if _request.Clinic.Name}
												{_request.Clinic.Name}
											{:else if _request.Clinic.NameFull}
												{_request.Clinic.NameFull}
											{:else if _request.Clinic.ID == 0}
												<span style="color: #b00000"
													>{"Удалена"}</span
												>
											{:else}
												{"Без названия"}
											{/if}
										</a>
									{:else}
										<span>
											{#if _request.Clinic.Name}
												{_request.Clinic.Name}
											{:else if _request.Clinic.NameFull}
												{_request.Clinic.NameFull}
											{:else if _request.Clinic.ID == 0}
												<span style="color: #b00000"
													>{"Удалена"}</span
												>
											{:else}
												{"Без названия"}
											{/if}
										</span>
									{/if}
								</span>
								{#if _request.Clinic.Adress}
									<span>Адрес: {_request.Clinic.Adress}</span>
								{/if}
							</div>
						{/if}
						<div class="mod__title">
							{#if _request.Created}
								<span>
									Создана: {_request.Created}
								</span>
							{/if}
							{#if _request.ModifiedDate}
								<span>Обработана: {_request.ModifiedDate}</span>
							{/if}
							{#if _request.ModifiedUser}
								<span>Кем: {_request.ModifiedUser}</span>
							{/if}
						</div>
						<div class="mod__title">
							{#if _request.ID}
								<span>
									ID: {_request.ID}
								</span>
							{/if}
							{#if _request.StatusName}
								<span class="mod__status">
									Статус: {_request.StatusName}
									<i
										style="background-color: #{_request.Color};"
									/>
								</span>
							{/if}
						</div>
					</div>
					{#if _request.Data}
						<div
							class="mod__content {DATA.newData[DATA.field_name][
								i
							].active
								? 'active'
								: ''} "
						>
							<div class="mod__content-wrap ">
								<div
									class="mod__content-wrap2 {$isMobile
										? 'mobile'
										: 'not_mobile'}"
								>
									<!-- {#if _request.Resource == "iMedClinic" && _request.Action == "edit" && _request.Data[0].Resource == "iMedClinicService"}
										<span class="mod__premod-status"
											>Заявка на изменение цен на услуги
											клиники</span
										>
									{/if} -->
									{#if _request.Resource == "iMedClinic" && _request.Action == "add"}
										<span class="mod__premod-status"
											>Заявка на добавление клиники</span
										>
									{/if}
									{#if _request.Resource == "iMedDoctor" && _request.Action == "add"}
										<span class="mod__premod-status"
											>Заявка на добавление специалиста</span
										>
									{/if}
									{#if _request.Resource == "iMedClinicDoctor" && _request.Action == "edit"}
										<span class="mod__title"
											>Заявка на добавление специалиста к
											клинике</span
										>
									{/if}
									<div
										class="mod__content-bg"
										on:click={() =>
											(DATA.newData[DATA.field_name][
												i
											].active = false)}
									/>
									{#each _request.Data as _data}
										{#if _data.DataValue}
											{#each _data.DataValue as _value}
												<div class="mod__data">
													<span
														class="mod__fieldname"
													>
														{#if _value.FieldTitle}
															<b
																>{_value.FieldTitle}</b
															>
															{#if _value.auxFormatted && _value.auxFormatted.length == 1}
																<span
																	>{_value
																		.auxFormatted[0]}</span
																>
															{/if}
															{#if _value.auxFormatted && _value.auxFormatted["ServiceID"]}
																<span
																	>{_value
																		.auxFormatted[
																		"ServiceID"
																	]}</span
																>
															{/if}
														{/if}
													</span>
													<span class="mod__value new"
														>Стало: {@html _value.NewValueFormatted ==
														0
															? "удалено"
															: _value.NewValueFormatted}</span
													>
													<span class="mod__value old"
														>Было: {@html _value.OldValueFormatted}</span
													>
												</div>
											{/each}
										{/if}
									{/each}

									<div
										class="modal"
										class:active={DATA.newData[
											DATA.field_name
										][i].active2}
									>
										<div
											class="modal__bg"
											on:click={() => {
												DATA.newData[DATA.field_name][
													i
												].active2 = false;
											}}
										/>
										<div class="modal__body">
											<i
												class="fas fa-times modal__cross"
												on:click={() => {
													DATA.newData[
														DATA.field_name
													][i].active2 = false;
												}}
											/>
											<span class="modal__title"
												>Подтверждение отказа заявки</span
											>
											<div
												class="modal__content scrollbar-white {$isMobile
													? 'mobile'
													: 'not_mobile'}"
											>
												<textarea
													placeholder="Причина отклонения заявки"
													class="scrollbar-white"
													bind:value={data.newData[
														data.field_name
													][i]["ChangeStatusReason"]}
												/>
											</div>
											<div class="modal__buttons">
												<span
													class="modal__button modal__save"
													on:click={() => {
														handleCancel(
															_request.ID,
															_request.ChangeStatusReason,
															i
														);
														DATA.newData[
															DATA.field_name
														][i].active2 = false;
													}}>Ок</span
												>
												<span
													class="modal__button modal__cancel"
													on:click={() => {
														DATA.newData[
															DATA.field_name
														][i].active2 = false;
													}}>Отмена</span
												>
											</div>
										</div>
									</div>

									<!-- {#if DATA.newData[DATA.field_name][i].changeStatusSwitch}
										<div
											class="mod__feedback"
											transition:slide
										>
											<textarea
												placeholder="Причина отклонения заявки"
												class="scrollbar-white"
												bind:value={data.newData[
													data.field_name
												][i]["ChangeStatusReason"]}
											/>
										</div>
									{/if} -->
									{#if _request.Status == 1}
										<div class="modal__buttons">
											<span
												class="modal__button modal__save button"
												on:click={() =>
													handleSave(_request.ID, i)}
											>
												{#if DATA.newData[DATA.field_name][i].buttonHandler == "save"}
													<div
														class="button__loading"
														transition:fade
													>
														<div
															class="button__spinner"
														/>
													</div>
												{/if}
												Принять</span
											>
											<span
												class="modal__button modal__cancel button"
												on:click={() => {
													DATA.newData[
														DATA.field_name
													][i].active2 =
														!DATA.newData[
															DATA.field_name
														][i].active2;
												}}
											>
												{#if DATA.newData[DATA.field_name][i].buttonHandler == "cancel"}
													<div
														class="button__loading"
														transition:fade
													>
														<div
															class="button__spinner"
														/>
													</div>
												{/if}
												Отказать</span
											>
										</div>
									{/if}

									{#if _request.History && _request.History.length > 0}
										<div class="mod__history">
											<span class="mod__history-title"
												>История заявок:
											</span>
											<ul>
												{#each _request.History as history_element}
													<li>
														<span
															>Дата: {history_element.Created
																? history_element.Created
																: ""}</span
														>
														<span
															>Кем: {history_element.User
																? history_element.User
																: ""}</span
														>
														<span
															>Причина: {history_element.Reason
																? history_element.Reason
																: ""}</span
														>
														<span
															>Было: {history_element.OldStatusName
																? history_element.OldStatusName
																: ""}</span
														>
														<span
															>Стало: {history_element.StatusName
																? history_element.StatusName
																: ""}</span
														>
													</li>
												{/each}
											</ul>
										</div>
									{/if}
								</div>
							</div>
						</div>
					{/if}
				</li>
			{/each}
		</ul>
	</div>
{/if}

<style lang="scss">
	.popup {
		position: fixed;
		z-index: 1000;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: auto;

		&__bg {
			cursor: pointer;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(0, 0, 0, 0.4);
			z-index: -1;
		}

		&__cross {
			position: absolute;
			cursor: pointer;
			top: 18px;
			right: 18px;
			font-size: 20px;
		}

		&__body {
			background: var(--bg-main-1);
			position: relative;
			border-radius: 16px;
			margin: 0 30px;
			overflow: hidden;
			display: flex;
			max-height: 80vh;
			max-width: 80vw;
			padding: 30px;
			flex-direction: column;
			> b {
				font-size: 20px;
				margin-right: 20px;
			}
		}
	}
	.button {
		display: flex;
		position: relative;
		overflow: hidden;
		&__loading {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #000000b8;
			display: flex;
			align-items: center;
			justify-self: center;
		}
		&__spinner {
			position: absolute;
			height: 18px;
			width: 18px;
			border: 3px solid transparent;
			border-top-color: var(--color-1);
			left: calc(50% - 12px);
			border-radius: 50%;
			animation: spin 2s linear infinite;
			&:before,
			&:after {
				content: "";
				position: absolute;
				border: 3px solid transparent;
				border-radius: 50%;
			}
			&:before {
				border-top-color: var(--color-1);
				top: -12px;
				left: -12px;
				right: -12px;
				bottom: -12px;
				animation: spin 3s linear infinite;
			}
			&:after {
				border-top-color: var(--color-1);
				top: 6px;
				left: 6px;
				right: 6px;
				bottom: 6px;
				animation: spin 4s linear infinite;
			}
		}
	}
	.mod {
		display: flex;
		flex-direction: column;
		&.inf {
			@media (min-width: 992px) {
				max-width: var(--module-width-1);
			}
			.mod {
				&__history {
					margin-top: 10px;
					display: flex;
					flex-direction: column;
					&-title {
						font-size: 14px;
						color: var(--text-gray-1);
						margin-bottom: 10px;
						display: flex;
					}
					> ul {
						display: flex;
						flex-direction: column;
						> li {
							display: flex;
							flex-direction: column;
							margin-bottom: 6px;
							font-size: 12px;
							color: var(--text-gray-1);
						}
					}
				}
				&__content {
					display: flex;
					flex-direction: column;
					&-wrap {
						display: flex;
						flex-direction: column;
						&2 {
							display: flex;
							flex-direction: column;
							padding-top: 20px;
							border-top: 1px solid #eaebf2;
						}
					}
				}
				&__list {
					display: block;
					flex-direction: column;
				}
				&__item {
					display: flex;
					flex-direction: column;
					padding: 5px 0;
					margin-bottom: 30px;
					border: solid 1px var(--color-1);
					border-radius: 20px;
					padding: 20px;
					box-shadow: 4px 4px 8px 0px #223c5033;
					background-color: var(--bg-main-1);
					position: relative;
					overflow: hidden;
					&:last-child {
						margin-bottom: 0;
					}
					&-header {
						display: flex;
						flex-wrap: wrap;
						margin: 0 -10px -10px 0;
						padding-bottom: 20px;
					}
					&-handled {
						position: absolute;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						background: #0000001c;
						top: 0;
						left: 0;
						bottom: 0;
						right: 0;
						z-index: 2;
						> span {
							font-size: 20px;
							color: var(--color-1);
							border: solid 1px;
							padding: 2px 10px;
							border-radius: 8px;
							background: white;
							margin-bottom: 6px;
							&:last-child {
								margin-bottom: 0;
							}
						}
					}
				}
				&__image {
					height: 40px;
					width: 40px;
					border-radius: 8px;
					flex-shrink: 0;
					overflow: hidden;
					display: flex;
					flex-direction: column;
					align-self: stretch;
					justify-content: space-evenly;
					margin: 0 16px 16px 0;
					> img {
						height: 100%;
						width: 100%;
						object-fit: cover;
					}
					&.blank {
						padding: 2px;
					}
				}
				&__status {
					display: flex;
					align-items: center;
					white-space: nowrap;
					> i {
						height: 16px;
						width: 16px;
						border-radius: 50%;
						display: flex;
						flex-shrink: 0;
						margin-left: 10px;
						border: solid 1px #2c303b2c;
					}
				}
				&__title {
					display: flex;
					flex-direction: column;
					align-self: stretch;
					justify-content: space-evenly;
					font-size: 14px;
					margin: 0 16px 16px 0;
					> span {
						word-break: break-all;
						margin-bottom: 6px;
						&:last-child {
							margin-bottom: 0;
						}
					}
				}
				&__data {
					display: flex;
					flex-direction: column;
					padding: 0 0 20px 0;
					&:first-child {
						padding-top: 20px;
					}
					&:last-child {
						padding-bottom: 0;
					}
				}
				&__fieldname {
					display: flex;
					flex-direction: column;
					> span {
						margin-top: 6px;
					}
				}
				&__value {
					display: flex;
					flex-direction: column;
					padding: 6px 0 6px 10px;
					word-break: break-word;
					&.old {
						color: gray;
					}
				}
				&__clinic {
					z-index: 100;
					display: flex;
					flex-direction: column;
					align-self: stretch;
					justify-content: space-evenly;
					font-size: 14px;
					margin: 0 16px 16px 0;
					> span {
						display: inline-block;
						margin-bottom: 6px;
					}
				}
			}
		}
		&.comp {
			@media (min-width: 992px) {
				max-width: var(--module-width-1);
			}
			.mod {
				&__history {
					margin-top: 10px;
					display: flex;
					flex-direction: column;
					&-title {
						font-size: 14px;
						color: var(--text-gray-1);
						margin-bottom: 10px;
						display: flex;
					}
					> ul {
						display: flex;
						flex-direction: column;
						> li {
							display: flex;
							flex-direction: column;
							margin-bottom: 6px;
							font-size: 12px;
							color: var(--text-gray-1);
						}
					}
				}
				&__content {
					z-index: 101;
					opacity: 0;
					display: none;
					position: fixed;
					height: 100vh;
					width: 100vw;
					top: 0;
					left: 0;
					align-items: center;
					justify-content: center;
					&.active {
						display: flex;
						opacity: 1;
					}

					&-wrap {
						border-radius: 20px;
						display: flex;
						flex-direction: column;
						overflow: hidden;
						background: var(--bg-main-1);
						max-width: 80vw;
						max-height: 80vh;
						min-width: 40vw;
						&2 {
							display: flex;
							flex-direction: column;
							overflow: overlay;
							padding: 20px;
							border-radius: 20px;
							box-shadow: 4px 4px 8px 0px #223c5033;

							&.not_mobile::-webkit-scrollbar {
								width: 12px;
								height: 12px;
							}

							&::-webkit-scrollbar {
								width: 0px;
								height: 0px;

								&-track {
									background: var(--bg-main-1);
									box-shadow: 0 0 2px #00000033;
								}

								&-thumb {
									background: var(--color-1);
									border-radius: 8px;
									transition: background-color 0.2s ease;
									border: 2px solid var(--bg-main-1);
								}
							}
						}
					}
					&-bg {
						cursor: pointer;
						position: absolute;
						top: 0;
						right: 0;
						bottom: 0;
						left: 0;
						background-color: #00000066;
						z-index: -1;
					}
				}
				&__list {
					display: flex;
					flex-direction: column;
				}
				&__item {
					border: solid 1px var(--color-1);
					border-radius: 8px;
					margin-bottom: 16px;
					overflow: hidden;
					display: flex;
					flex-direction: column;
					position: relative;
					min-height: 50px;

					&-header {
						display: flex;
						flex-wrap: wrap;
						margin: 0 -16px -16px 0;
						padding: 10px;
					}
					&-clickable {
						cursor: pointer;
						position: absolute;
						z-index: 1;
						top: 0;
						left: 0;
						bottom: 0;
						right: 0;
					}
					&-handled {
						position: absolute;
						background: #0000001c;
						top: 0;
						left: 0;
						bottom: 0;
						right: 0;
						z-index: 2;
						display: flex;
						align-items: center;
						justify-content: center;
						> span {
							font-size: 20px;
							color: var(--color-1);
							border: solid 1px;
							padding: 2px 10px;
							border-radius: 8px;
							background: var(--bg-main-1);
							margin-right: 6px;
							&:last-child {
								margin-right: 0;
							}
						}
					}
				}
				&__status {
					display: flex;
					align-items: center;
					white-space: nowrap;
					> i {
						height: 16px;
						width: 16px;
						border-radius: 50%;
						display: flex;
						flex-shrink: 0;
						margin-left: 10px;
						border: solid 1px #2c303b2c;
					}
				}
				&__title {
					display: flex;
					flex-direction: column;
					align-self: stretch;
					justify-content: space-evenly;
					font-size: 14px;
					margin: 0 16px 16px 0;
					&:first-child {
						margin-left: auto;
					}
					> span {
						word-break: break-all;
						margin-bottom: 6px;
						&:last-child {
							margin-bottom: 0;
						}
					}
				}
				&__data {
					display: flex;
					flex-direction: column;
					padding: 10px 0 20px;
				}
				&__fieldname {
					display: flex;
					flex-direction: column;
					> span {
						margin-top: 6px;
					}
				}
				&__value {
					display: flex;
					flex-direction: column;
					padding: 6px 0 6px 10px;
					word-break: break-word;
					&.old {
						color: gray;
					}
				}
				&__image {
					height: 50px;
					width: 50px;
					border-radius: 8px;
					display: flex;
					flex-direction: column;
					align-self: stretch;
					justify-content: space-evenly;
					font-size: 14px;
					margin: 0 16px 16px 0;

					> img {
						height: 100%;
						width: 100%;
						object-fit: cover;
					}
				}
				&__clinic {
					z-index: 100;
					display: flex;
					flex-direction: column;
					align-self: stretch;
					justify-content: space-evenly;
					font-size: 14px;
					margin: 0 16px 16px 0;
					> span {
						display: inline-block;
						margin-bottom: 6px;
					}
				}
			}
		}
	}
	.themes {
		display: flex;
		flex-direction: column;
		margin-bottom: 20px;
		&__title {
			font-weight: bold;
			font-size: 16px;
			line-height: 1.5;
			margin-bottom: 10px;
		}
		&__option {
			margin: 0 10px 10px 0;
			cursor: pointer;
			&.active {
				color: var(--color-1);
			}
		}
		&__options {
			display: flex;
			flex-wrap: wrap;
		}
	}
</style>
